import { Orders } from "pages/Orders";
import { Settings } from "pages/Settings";
import { Home } from "pages/Home";
import { Profile } from "pages/Profile";
import { Groups } from "pages/Groups";
import { Statistics } from "pages/Statistics";
import { QRCodes } from "pages/QRCodes";
import Documentation from "pages/Documentation";

import { FaHome, FaUser, FaUtensils, FaCog, FaQrcode, FaListAlt, FaBook, FaChartBar } from 'react-icons/fa';
import ItemsNew from "pages/DishesNew";

export const pagesDashboards = [
  { name: "Home", href: "/home", pageType: "up", element: <Home />, icon: <FaHome /> },
  { name: "Dishes *", href: "/dishes-new", pageType: "up", element: <ItemsNew />, icon: <FaUtensils /> },
  // { name: "Groups", href: "/groups", pageType: "up", element: <Groups />, icon: <FaUtensils /> },
  { name: "QR Codes", href: "/qr-code-generator", pageType: "up", element: <QRCodes />, icon: <FaQrcode /> },
  
  { name: "Orders", href: "/orders", pageType: "down", element: <Orders />, icon: <FaListAlt /> },
  { name: "Settings", href: "/settings", pageType: "down", element: <Settings />, icon: <FaCog /> },
  { name: "Statistics", href: "/statistics", pageType: "down", element: <Statistics />, icon: <FaChartBar /> },
  { name: "Documentation", href: "/documentation", pageType: "down", element: <Documentation />, icon: <FaBook /> },
  { name: "Profile", href: "/profile", pageType: "down", element: <Profile />, icon: <FaUser /> },


];

export const initialState = [
  {
    order_id: 2,
    queryId: 0,
    comment: "",
    totalPrice: "58.00",
    optionDelivery: "on_site",
    paymentMethod: "card",
    order_date: null,
    cartItems:
      '[{"id":2,"title":"Coca","price":8,"quantity":2},{"id":1,"title":"Falafel","price":15,"description":"Falafel_description","toppings":[],"quantity":2,"selectedToppings":[]}]',
    address: "",
    user_name: "yair770",
    user_id: 386212074,
  },

  {
    order_id: 9,
    queryId: 0,
    comment: "",
    totalPrice: "123123.00",
    optionDelivery: "on_site",
    paymentMethod: "card",
    order_date: null,
    cartItems:
      '[{"id":1,"title":"Falafel","price":15,"description":"Falafel_description","toppings":[],"quantity":2,"selectedToppings":[]}]',
    address: "",
    user_name: "yair770",
    user_id: 386212074,
  },
  {
    order_id: 10,
    queryId: 0,
    comment: "",
    totalPrice: "123123.00",
    optionDelivery: "on_site",
    paymentMethod: "card",
    order_date: null,
    cartItems:
      '[{"id":1,"title":"Falafel","price":15,"description":"Falafel_description","toppings":[],"quantity":2,"selectedToppings":[]}]',
    address: "",
    user_name: "yair770",
    user_id: 386212074,
  },
];

export const creditCardInitialData = {
  cardNumber: "1234567890123456",
  expiryDate: "12/23",
  cvv: "123",
  email: "john.doe@example.com",
}

 
export const currencies = [
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "RUB", symbol: "₽" },
  { code: "GBP", symbol: "£" },
  { code: "ILS", symbol: "₪" }, // Шекель (Израиль)
 ]